var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceWinnerBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 817,
    viewBox: "0 0 300 817",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4174_304816",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 300,
    height: 820
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 820,
    fill: "url(#paint0_linear_4174_304816)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4174_304816)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 529,
    fill: "#121A2A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 529,
    fill: "url(#paint1_radial_4174_304816)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4174_304816)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 295 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 285 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 275 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 265 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 255 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 245 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 235 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 225 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 215 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 205 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 195 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 185 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 175 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 165 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 155 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 145 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 135 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 125 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 115 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 105 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 95 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 85 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 75 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 65 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 55 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 45 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 35 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 25 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 15 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 5 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -5 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -15 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -25 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -35 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -45 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -55 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -65 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -75 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -85 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -95 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -105 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -115 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -125 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -135 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -145 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -155 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -165 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -175 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -185 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -195 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -205 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -215 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -225 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -235 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -245 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -255 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -265 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -275 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -285 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -295 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -305 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -315 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -325 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -335 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -345 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -355 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -365 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -375 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -385 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -395 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -405 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -415 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -425 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -435 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -445 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -455 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -465 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -475 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -485 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -495 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -505 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -515 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -525 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -535 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -545 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -555 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -565 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -575 -0.267578)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -585 -0.267578)",
    fill: "#040811"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4174_304816)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 293 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 283 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 273 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 263 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 253 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 243 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 233 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 223 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 213 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 203 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 193 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 183 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 173 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 163 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 153 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 143 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 133 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 123 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 113 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 103 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 93 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 83 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 73 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 63 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 53 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 43 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 33 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 23 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 13 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 3 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -7 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -17 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -27 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -37 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -47 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -57 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -67 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -77 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -87 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -97 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -107 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -117 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -127 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -137 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -147 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -157 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -167 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -177 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -187 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -197 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -207 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -217 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -227 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -237 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -247 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -257 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -267 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -277 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -287 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -297 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -307 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -317 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -327 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -337 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -347 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -357 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -367 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -377 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -387 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -397 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -407 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -417 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -427 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -437 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -447 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -457 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -467 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -477 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -487 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -497 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -507 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -517 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -527 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -537 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -547 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -557 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -567 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -577 333.732)",
    fill: "#040811"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 881,
    height: 2,
    transform: "matrix(0.866025 0.5 0.500004 -0.866023 -587 333.732)",
    fill: "#040811"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4174_304816",
    x1: 150,
    y1: 70,
    x2: 150,
    y2: 503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4174_304816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.5 8.5) rotate(60.476) scale(337.873 293.15)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEA40D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEA40D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4174_304816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 334,
    fill: "white",
    transform: "matrix(-1 0 0 1 300 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4174_304816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 302,
    height: 334,
    fill: "white",
    transform: "matrix(-1 0 0 1 300 334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceWinnerBg1);
export default __webpack_public_path__ + "static/media/place-winner-bg-1.726ebaf231569dfd7d4491f9cc567b34.svg";
export { ForwardRef as ReactComponent };